import React, {Fragment} from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer'
import Scrollbar from '../../components/scrollbar/scrollbar'
import FaqSection from '../../components/Faq/FaqSection'
// import { FooterWave } from '../../components/footer/Footer';
// import PageTitle from '../../components/pagetitle/PageTitle';

const FaQPage =() => {
    return(
        <Fragment>
            <Helmet>
                <title>FAQ | Up Dental of Manvel TX</title>
                <meta name="description" content="FAQ | Up Dental of Manvel TX" />
                <meta name="keywords" content="dental, dentist, Manvel, treatment" />
            </Helmet>
            <Navbar hclass={'wpo-header-style-2'}/>
            {/* <PageTitle pageTitle={'Frequently Asked Question'} pagesub={''} className={'wpo-page-title'}/>  */}
            <FaqSection />
           
            
            {/* <FooterWave /> */}
            {/* <Footer footerClass={'wpo-site-footer-s2'}/> */}
            <Footer />
            <Scrollbar/>
        </Fragment>
    )
};

export default FaQPage;
